export default __webpack_public_path__ + "static/media/bg.cc915bd7.webp";